import {
  IProductEnterpriseParam,
  IProductEnterprise,
  IAddEnterpriseSetup,
  IUpdateCompanyConfig,
} from '../../../types/air-splitting/products/enterpriseSetup';
import { EPaymentChannel, IAgentFeeItem, IProductUsageConfig } from '../../../types/common';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl, isNull } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 分账产品 - 企业配置 - 查询企业
 */
export async function queryEnterprises(param: IProductEnterpriseParam) {
  let data = [] as IProductEnterprise[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IProductEnterpriseParam;

  try {
    const { code, context, message } = await Http.get<{ data: IProductEnterprise[]; total: number }>(`${hostUrl}/disburse/company-channel-config/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IProductEnterprise[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 分账产品 - 企业配置 - 企业分账明细 - 启用/禁用
 */
export async function changeEnterpriseBills(configId: number, endabled: boolean) {
  const action = endabled ? 'enable' : 'disable';

  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/disburse/company-channel-config/${action}/${configId}`);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 空中分账 - 分账产品 - 企业配置 - 企业分账明细 - 删除
 */
export async function deleteEnterpriseBills(id: number) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/disburse/company-channel-config/delete/${id}`);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
/**
 * 空中分账 - 分账产品 - 企业管理 - 新增、编辑
 */
export async function saveEnterprisesSetup(param: IAddEnterpriseSetup, edit: boolean) {
  const action = edit ? 'modify' : 'add';

  param = JSON.parse(JSON.stringify(param)) as IAddEnterpriseSetup;

  const postParam = edit
    ? {
      id: param.id,
      settleServiceRate: param.settleServiceRate,
    }
    : {
      channelId: param.channelId,
      agentId: param.agentId,
      companyId: param.companyId,
      settleServiceRate: param.settleServiceRate ? Number(param.settleServiceRate) : undefined,
    };

  try {
    const { code, message } = await Http.post<IAddEnterpriseSetup>(`${hostUrl}/disburse/company-channel-config/${action}`, postParam);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 空中分账 - 分账产品 - 企业配置 - 上级代理商费率查询
 */
export async function queryEBDAgentFeeList(configId: number) {
  let data = [] as IAgentFeeItem[];

  try {
    const { code, context, message } = await Http.get<IAgentFeeItem[]>(`${hostUrl}/disburse/company-channel-config/get-config-rate`, { configId });

    if (code === EAxiosResponseCode.Succeed) {

      data = context || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 分账产品 - 企业配置 - 获取代理商费率
 */
export async function querAgentDetail(agentId: number, channelId) {
  let data = {} as { agentId: number; agentName: string; agentServiceRate: number };

  try {
    const { code, context, message } = await Http.get<{ agentId: number; agentName: string; agentServiceRate: number }>(`${hostUrl}/disburse/product-config/get-product-config`, {
      agentId,
      channelId,
    });

    if (code === EAxiosResponseCode.Succeed) {

      data = context || {} as { agentId: number; agentName: string; agentServiceRate: number };
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 分账产品 - 企业产品 - 通道产品费率查询
 */
export async function queryCompanyUsageList(companyId: number, isDetail = false, channelId?: EPaymentChannel) {
  let data = [] as IProductUsageConfig[];

  const params = {
    companyId,
    channelId: isNull(channelId) ? undefined : channelId,
  };

  try {
    const { code, context, message } = await Http.get<IProductUsageConfig[]>(`${hostUrl}/disburse/company-usage/${isDetail ? 'detail' : 'cost-list'}`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IProductUsageConfig[];

      data = items || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 分账产品 - 企业产品 - 更新通道产品费率
 */
export async function updateCompanyUsage(params: IUpdateCompanyConfig) {
  try {
    const { code, message } = await Http.post(`${hostUrl}/disburse/company-usage/modify`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}